import { ApplicationError } from "@/error/ApplicationError";
import type { UnknownRecord } from "@/utils/type";

export class NoSuccessError extends ApplicationError {
  constructor(
    message: string,
    endpoint: string,
    contexts: { request: UnknownRecord; response: NoSuccessResponse },
  ) {
    super(`NoSuccessError: ${message}`, `Server call unsuccessful to ${endpoint}`, contexts);
  }

  get response(): NoSuccessResponse {
    return this.contexts.response as NoSuccessResponse;
  }
}

interface NoSuccessResponse extends UnknownRecord {
  message: string;
  code?: string;
  details?: unknown;
}
